import nlp from 'compromise';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import isDateValid from 'date-fns/isValid';
import { titleCase } from 'voca';
export const formatPetBreed = (value: string) => {
  const formattedName = nlp(value).match('#ProperNoun').text() || titleCase(value);
  return formattedName;
};
export const formatPetName = (value: string) => {
  const formattedName = nlp(value).match('#ProperNoun').text() || titleCase(value);
  return formattedName;
};
export const getPossessivePetName = (value: string) => {
  const formattedName = nlp(value).match('#ProperNoun').nouns().toPossessive().text() || `${titleCase(value)}'s`;
  return formattedName;
};
export const tryValidatingOrReturnFallbackBirthday = (value: string) => {
  /**
   * The goal is to avoid less friction so that we can push more users to the platform
   * Try to parse and validate it and if it fails, set a default value ( 01/01/{currentYear} )
   */
  const parseISODate = parseISO(value);
  /**
   * First day of the year
   */
  const fallbackDate = new Date(new Date().getFullYear(), 0, 1);

  /**
   * The endpoint expects the format to be 'yyyy-MM-DD'
   */
  const birthday = isDateValid(parseISODate) ? format(parseISODate, 'yyyy-MM-dd') : format(fallbackDate, 'yyyy-MM-dd');
  return birthday;
};
export type ChatBotStepProps = {
  previousStep: Record<string, unknown>;
  step: Record<string, unknown>;
  steps: Record<string, Record<'id' | 'message' | 'value' | 'metadata', string>>;
  triggerNextStep: () => void;
};
export type CustomChatBotStepProps = {
  formatPetBreed: (value: string) => string;
  formatPetName: (value: string) => string;
  getPossessivePetName: (value: string) => string;
  tryValidatingOrReturnFallbackBirthday: (value: string) => string;
};
export type VetChatMessageContainerProps = {
  children: (props: ChatBotStepProps & CustomChatBotStepProps) => JSX.Element;
};
/**
 * A container component to be rendered as the "wrapper" or a "container" of
 * any custom component that is passed to the <ChatBot /> steps
 * This is a custom container component that will allow the custom component to
 * retrieve values from different steps since we cannot use any state management
 * This container component follows the technique "render prop" to be compatible
 * with the package's API
 */
export const VetChatMessageContainer = ({
  children,
  ...rest
}: VetChatMessageContainerProps) => children({
  formatPetBreed,
  formatPetName,
  getPossessivePetName,
  tryValidatingOrReturnFallbackBirthday,
  ...rest
} as unknown as ChatBotStepProps & CustomChatBotStepProps);